import { Describe, ListaParcelas, Parcelas } from './styles'

import { calculateValorParcela } from '../../utils/calcParcela'
import { calculateDateRange } from '../../utils/calcDateRange'

interface Props {
    quantParcelas: number
    valueLink: number
    data_Liquidacao: string
}

const TableParcelas = ({
    quantParcelas,
    valueLink,
    data_Liquidacao,
}: Props) => {
    function renderRowParcelas() {
        return Array(quantParcelas)
            .fill(0)
            .map((elem, i) => {
                const { dataLiquidacaoInicial, dataLiquidacaoFinal } =
                    calculateDateRange(data_Liquidacao, i)
                const valorParcela = calculateValorParcela(
                    valueLink,
                    quantParcelas,
                    i
                )

                return (
                    <tr key={i}>
                        <td>{i + 1}º parcela</td>
                        <td>
                            {Number(valorParcela).toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </td>
                        <td>
                            {dataLiquidacaoInicial.format('DD/MM/YYYY')} ~{' '}
                            {dataLiquidacaoFinal.format('DD/MM/YYYY')}
                        </td>
                    </tr>
                )
            })
    }
    return (
        <>
            <Parcelas>
                <ListaParcelas>
                    <thead>
                        <tr>
                            <th>Parcela</th>
                            <th>Valor</th>
                            <th>Vencimento</th>
                        </tr>
                    </thead>

                    <tbody>{renderRowParcelas()}</tbody>
                </ListaParcelas>
            </Parcelas>
            <Describe>
                <span>
                    * As datas de vencimento podem variar em até 3 dias,
                    dependendo da data de vencimento das unidades recebíveis do
                    pagador (não sendo contabilizado sábado e domingo).
                </span>
            </Describe>
        </>
    )
}

export default TableParcelas
